module.exports = __webpack_public_path__ + "img/modalDownArrow.f2da6f89.svg";